"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var rc_menu_1 = __importDefault(require("rc-menu"));
var DropdownMenuDivider_1 = __importDefault(require("./DropdownMenuDivider"));
var DropdownMenuGroupHeader_1 = __importDefault(require("./DropdownMenuGroupHeader"));
var DropdownMenuHeader_1 = __importDefault(require("./DropdownMenuHeader"));
var DropdownMenuItem_1 = __importDefault(require("./DropdownMenuItem"));
var DropDownSubMenu_1 = __importDefault(require("./DropDownSubMenu"));
var DropdownMenu = function (props) { return react_1.jsx(rc_menu_1.default, __assign({}, props, { prefixCls: "sixsense-menu" })); };
DropdownMenu.Header = DropdownMenuHeader_1.default;
DropdownMenu.Divider = DropdownMenuDivider_1.default;
DropdownMenu.Item = DropdownMenuItem_1.default;
DropdownMenu.GroupHeader = DropdownMenuGroupHeader_1.default;
DropdownMenu.SubMenu = DropDownSubMenu_1.default;
exports.default = DropdownMenu;
